import type { LayersList } from "@deck.gl/core";
import type { GoogleMapsOverlay } from "@deck.gl/google-maps";

export type DeckOverlayHandle = Pick<GoogleMapsOverlay, "setMap" | "setProps">;

const syncDeckOverlay = (
  overlay: DeckOverlayHandle,
  map: google.maps.Map,
  layers: LayersList,
  attached: boolean
): boolean => {
  if (layers.length === 0) {
    if (!attached) {
      return false;
    }
    overlay.setProps({ layers: [] });
    overlay.setMap(null);
    return false;
  }

  // deck.gl's _onRemove hides all layers with layerFilter and a re-attach reuses the same Deck, so every attached flush clears it.
  overlay.setProps({ layerFilter: null, layers });
  if (!attached) {
    overlay.setMap(map);
    overlay.setProps({ layerFilter: null });
  }
  return true;
};

export default syncDeckOverlay;
